import { IGetListParams } from '../../base/base.service';
import { IGetShiftListParams, IShift, ShiftService } from '../../services/shifts.service';
import * as moment from 'moment';
import * as _ from 'lodash';
class DashboardOpenshiftsController {
    private shifts: IShift[];
    constructor(private ShiftService: ShiftService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getShift();
    }

    public getShift = () => {
        var params: IGetShiftListParams = {
            from: moment().format('YYYY-MM-DD'),
            till: moment().add(1, 'w').format('YYYY-MM-DD'),
            includeSubscriptions: false,
        }

        this.ShiftService.getFilter(params).then((shifts) => {
            this.shifts = shifts;
            // this.shifts.forEach((shift) => {
                
            // })

            this.shifts = _.remove(this.shifts, function(value, index) {
                if(value.status){
                    return value.status < 6;
                }
            });
        })
    }

    public isSameDay = (start, end) => {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        } else {
            return false;
        }
    }
}

export const dashboardOpenshiftsComponent = {
    controller: DashboardOpenshiftsController,
    template: require('./dashboard.openshifts.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.openshifts.component.ts